import React, { ChangeEventHandler, FocusEventHandler } from 'react'

interface IDatePickerProps {
  id: string
  value: string
  min?: string
  max?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
}

export const DatePicker = (props: IDatePickerProps) => {
  return (
    <input
      type="date"
      id={props.id}
      value={props.value}
      min={props.min}
      max={props.max}
      onChange={props.onChange}
      onBlur={props.onBlur}
    />
  )
}
